import { Features } from '@amzn/atoz-shiftapp-types';

declare global {
    interface Window {
        FEATURES?: {
            ATOZ_API_FOR_PUNCH_ENABLED?: boolean;
            ATOZ_VACCINE_BADGE?: boolean;
            FEATURE_TIMEOFF?: boolean;
            LOCATION_AWARE_WEB_PUNCH?: boolean;
        };
    }
}

export const getFeatures = (): Features => {
    const APP_ROOT = document.getElementById('atoz-shift-management-page-root');
    const dataAttrs = APP_ROOT?.dataset;
    const popstarFeatures = new Set<string>(
        JSON.parse((dataAttrs?.popstarFeatures || '[]').replace(/'/g, '"'))
    );
    const features = window.FEATURES || {};

    return {
        useUnifiedPunchesAPIForWeb: popstarFeatures.has(
            'use_unified_punches_api_for_web'
        ),
        isPunchEditForWebEnabled: popstarFeatures.has('punch_edit_for_web'),
        isMissedPunchClickableRowForWebEnabled: popstarFeatures.has(
            'missed_punch_clickable_row_for_web'
        ),
        isPopstarTaaFeaturesOverrideEnabled: popstarFeatures.has(
            'popstar_taa_features_enabled'
        ),
        isPunchEditFeatureEnabled: popstarFeatures.has('feature_punch_edit'),
        isPunchCorrStatusV1Enabled: popstarFeatures.has(
            'punch_correction_status_v1'
        ),
        canDeleteDuplicatePunch: popstarFeatures.has('delete_duplicate_punch'),
        isDeleteMpcaMpcsForWebEnabled: popstarFeatures.has(
            'delete_mpca_mpcs_punch_for_web'
        ),
        hasUnverifiedMissedPunchLimit: popstarFeatures.has(
            'limit_unverified_punch'
        ),
        atozApiForPunchEnabled: features.ATOZ_API_FOR_PUNCH_ENABLED || false,
        ctkPolicy: popstarFeatures.has('feature_ctk_report'),
        isVaccineBadgeEligible:
            features.ATOZ_VACCINE_BADGE ||
            popstarFeatures.has('covid_test_lite_reporting') ||
            popstarFeatures.has('vaccination_badge'),
        newsAppEnabled: dataAttrs?.featureNewsApp === 'true',
        myVoiceEnabled: popstarFeatures.has('myvoiceweb'),
        shoutOutsAppEnabled: dataAttrs?.featureShoutOutsApp === 'true',
        locationAwareWebPunchEnabled:
            features.LOCATION_AWARE_WEB_PUNCH || false,
        newVoluntaryTimeEnabled: dataAttrs?.newVoluntaryTimeEnabled === 'true',
        payBreakdownEnabled: popstarFeatures.has(
            'shift_management_app_pay_breakdown'
        ),
        punchAutomationPolicy:
            popstarFeatures.has('feature_mpca_mpa_report') &&
            dataAttrs?.featurePunchAutomationCorrection === 'true',
        schedulePageEnabled: dataAttrs?.featureMySchedule === 'true',
        selfServiceResignationEnabled:
            dataAttrs?.canViewSelfResignation === 'true',
        taaTimeoffRequestEnabled:
            dataAttrs?.featureTaaTimeoffRequest === 'true',
        timeoffEnabled: popstarFeatures.has('shift_management_app_time_off'),
        useTaaDashboardComponents: popstarFeatures.has(
            'v3_use_taa_dashboard_components'
        ),
        webPunchEnabled: dataAttrs?.featureWebPunch === 'true',
        punchCorrStatusEnabled: popstarFeatures.has('punch_correction_status'),
        isTimecardModalEnabled: popstarFeatures.has('timecard_modal'),
        showRoundedPunch: popstarFeatures.has('AtoZTime:ShowRoundedPunch'),
        isSubmitMissedPunchV2Enabled: popstarFeatures.has(
            'AtoZTime:MissPunchV2'
        ),
        isPendingPunchesOnTimecardEnabled:
            popstarFeatures.has('AtoZTime:AtoZTimecardPendingPunches') &&
            popstarFeatures.has('feature_clock_geolocation_async_punch'),
        canViewPunches: popstarFeatures.has('feature_view_punches'),
        canSubmitMissedPunch:
            popstarFeatures.has('feature_mpca_mpa_report') ||
            popstarFeatures.has('feature_ctk_report'),
        isLearnHubAppEnabled: popstarFeatures.has('learn_hub_web'),
        isPreHireIngressWidgetEnabled: popstarFeatures.has(
            'pre_hire_experience_web_home_ingress'
        ),
        findShiftsAPICallRedesign: popstarFeatures.has(
            'find_shifts_api_call_redesign'
        ),
        smaApiUsEastEnabled: popstarFeatures.has(
            'ShiftsApp:ApiMigrationUsEast'
        ),
        hasSkillOnShift: popstarFeatures.has(
            'shift_management_app_skill_on_shift'
        ),
        isTimeCardPunchWebEnabled: popstarFeatures.has(
            'timecard_punch_section_for_web'
        ),
        isTimeCardTaskListWebEnabled: popstarFeatures.has(
            'timecard_task_list_for_web'
        ),
        vtoWebApp: popstarFeatures.has('vto_web_app'),
        canFilterJobTypesOnFindShiftPage: popstarFeatures.has(
            'shift_management_app_filter_job_type'
        ),
        canAccessLocationEligibility: popstarFeatures.has(
            'shift_management_app_location_eligibility'
        ),
        pantherVtoDisabled: popstarFeatures.has(
            'shift_management_app_panther_vto_disabled'
        ),
        isATPlusTemporalRoutingEnabled: popstarFeatures.has(
            'atplus_temporal_routing'
        ),
        canSeeWeeklySchedule: popstarFeatures.has(
            'shift_management_app_weekly_schedule_web'
        ),
        isExtendPunchEligibilityForWebEnabled: popstarFeatures.has(
            'timecard_extend_punch_eligibility_for_web'
        ),
        isExtendPunchEligibilityForNativeEnabled: popstarFeatures.has(
            'timecard_extend_punch_eligibility_for_native'
        ),
        isNativeFindShiftsPageEnabled: popstarFeatures.has(
            'shift_management_app_native_find_shifts_page'
        ),
        hasNewPayPage: popstarFeatures.has('new_pay_page'),
        swapApp: popstarFeatures.has('swap_app'),
        isMergedShiftEnabled: popstarFeatures.has('merged_shift'),
        hasLegacyClockPunch: popstarFeatures.has('legacy_clock_punch')
    };
};
